import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import Field from 'src/components/10-atoms/form/Field';
import { getFieldError, getFieldState } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import useFormState from 'src/components/10-atoms/form/hooks/useFormState';
import TextInput from 'src/components/10-atoms/form/inputs/TextInput';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
const NoteTabFormDrawer = ({ noteID, noteTab, onSubmit, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const [formState, formActions] = useFormState({
        fields: {
            title: getFieldState(noteTab?.data.title ?? ''),
        },
    }, {
        fieldValidations: {
            title({ value }) {
                if (!value || value.trim().length === 0) {
                    return 'Title is required';
                }
                if (value.length > 200) {
                    return 'Title cannot exceed 200 characters';
                }
                return true;
            },
        },
    });
    const isEditMode = !!noteTab;
    const handleSubmit = useStableCallback(() => {
        if (!formActions.validateForm()) {
            return;
        }
        onSubmit({ title: formState.fields.title.value });
    });
    return (React.createElement(BottomDrawerLayout, null,
        React.createElement(BottomDrawerLayout.Title, null, isEditMode ? 'Edit Tab' : 'Add Tab'),
        React.createElement(BottomDrawerLayout.ScrollableBody, null,
            React.createElement(Field, { label: "Title", error: getFieldError(formState.fields.title.errors) },
                React.createElement(TextInput, { autoFocus: !isEditMode, placeholder: "Enter tab title", value: formState.fields.title.value, onChange: formActions.fields.title.setValue, maxLength: 200 }))),
        React.createElement(BottomDrawerLayout.Actions, { btw: 1, spacing: theme.spacing.standard.md, pv: theme.spacing.standard.sm },
            React.createElement(Button, { flex: true, onPress: handleSubmit }, isEditMode ? 'Update' : 'Create'))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    scrollView: {
        flex: 1,
    },
    scrollContent: {
        padding: theme.spacing.page,
        paddingBottom: theme.spacing.standard.xl,
    },
    submitButton: {
        marginTop: theme.spacing.standard.md,
    },
}));
export default NoteTabFormDrawer;
